import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { GemstoneSize } from 'src/app/interfaces/gemstone-size';
import { StoneSizesProviderService } from 'src/app/providers/stone-sizes/stone-sizes.provider.service';

@Injectable({
  providedIn: 'root'
})
export class StoneSizesService extends ApiService<GemstoneSize, StoneSizesProviderService> {
  private providerService = inject(StoneSizesProviderService);
  protected override get provider(): StoneSizesProviderService {
    return this.providerService;
  }
}
